// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.alignCenter {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.w100 {\n  width: 90px !important;\n}\n.w180 {\n  width: 160px !important;\n}\n.w20 {\n  width: 20px !important;\n}\n.w120 {\n  width: 120px !important;\n}\n", ""]);
// Exports
module.exports = exports;
